export default class Notify {
  delivery(body) {
    let insertHere = document.getElementById('notify-body');
    insertHere.style="display:block;";
    insertHere.innerHTML = body+'';
    setTimeout(() => {
      insertHere.style='';
      insertHere.innerHTML='';
    },3000);
  }
}
